import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { merchantsService } from "./services/Merchants.service";
import MerchantTable from "./MerchantsTable";
import MerchantForm from "./MerchantForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10,
  imageUrl: null
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false
};

const initailGetState = {
  fetchingRow: false,
  fetchedRow: false,
  fetchingError: null,
  selectedRow: null
};

const initailDeleteState = {
  deleting: false,
  deleted: false,
  deleteError: null,
  deleteResponse: null
};

const initailUpdateLocationState = {
  updatingLocations: false,
  locationsUpdated: false,
  locationResponse: null,
  locationError: null,
  hasParamsLocation: false
};

const initailLocationState = {
  fetchingLocations: false,
  locationsFetched: false,
  merchantLocations: null,
  fetchLocationsError: null
};

class ManageMerchants extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    ...initailDeleteState,
    ...initailUpdateLocationState,
    ...initailLocationState,
    isDeleteButton: false,
    storeInitialLocations: null
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAll({ pageNum: pageNum + 1, pageSize });
  }

  isObjectDifferent = (obj1, obj2) => {
    ///check the length of the array if change return true.
   
    try {
      if (obj1 !== null) {
       
        if (obj1.length === obj2.length) {
          //loop through and check only the address
          for (let i = 0; i < obj1.length; i++) {
            //check if it the same.
            if (obj1[i].address !== obj2[i].address) {
              return true;
            }
            if (obj1[i].lat !== obj2[i].lat) {
              return true;
            }
            if (obj1[i].lng !== obj2[i].lng) {
              return true;
            }
          }
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } catch (e) {
      console.error(e);
    }
  };

  getAll = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await merchantsService.getAllMerchants(params);
      if (response) {
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          data: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  createRequestBody = requestObject => {
    const { name, address, url } = requestObject;
    const requestBody = {
      name,
      address,
      url
    };
    return requestBody;
  };

  updateMerchantLocations = async (locations, merchantId, dontShowToast) => {
    this.setState({
      ...this.state,
      updatingLocations: true,
      locationsUpdated: false,
      locationResponse: null,
      locationError: null
    });
    const request = {
      locations: locations.map(location => ({
        lat: location.lat,
        lng: location.lng,
        address: location.address
      }))
    };
  
    try {
      let response = await merchantsService.updateLocations(
        request,
        merchantId
      );
      if (response) {
        this.setState({
          ...this.state,
          updatingLocations: false,
          locationsUpdated: true,
          locationResponse: response,
          locationError: null
        });
        
        if (dontShowToast) {
          toast.success("Merchant locations created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        }
      }
    } catch (error) {
      this.setState(
        {
          ...this.state,
          locationError: error,
          updatingLocations: false
        },
        () => {
          toast.error("Failed to create merchant locations", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        }
      );
    }
  };

  addMerchant = async requestBody => {
 
    const { pageSize, selectedRow } = this.state;
    const requestObject = this.createRequestBody(requestBody);

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,
      formResponse: null,
      formError: null
    });
    try {
      let response = await merchantsService.addMerchant(
        requestObject,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState(
          {
            ...this.state,
            submitting: false,
            submitted: true,
            formResponse: response,
            formError: null
          },
          () => {
            if (
              this.state.formResponse &&
              this.state.formResponse.data &&
              this.state.formResponse.data.id &&
              requestBody.locations &&
              requestBody.locations.length
            ) {
              let dontShowToast = this.isObjectDifferent(
                this.state.storeInitialLocations,
                requestBody.locations
              );
              this.updateMerchantLocations(
                requestBody.locations,
                this.state.formResponse.data.id,
                dontShowToast
              );
            }
          }
        );

        this.getAll({ pageNum: 1, pageSize });
        if (!selectedRow) {
          toast.success("Merchant created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        } else {
          toast.success("Merchant updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.resetButton();
        }
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false
      });
    }
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAll(params);
   
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  getMerchantLocations = async merchantId => {
    this.setState({
      ...this.state,
      fetchingLocations: true
    });
    try {
      let response = await merchantsService.getAllMerchantLocations(
        merchantId,
        {
          pageNum: 0,
          pageSize: 999
        }
      );
      if (response) {
        this.setState({
          ...this.state,
          fetchingLocations: false,
          locationsFetched: true,
          merchantLocations: response,
          fetchLocationsError: null,
          storeInitialLocations: response.data
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetchingLocations: false,
        locationsFetched: false,
        fetchLocationsError: error
      });
    }
  };

  getMerchant = async (params, action) => {
    this.setState({
      isDeleteButton: false,
      ...this.state,
      ...initialSubmitState,
      fetchingRow: true,
      fetchingError: null
    });
    try {
      let response = await merchantsService.getMerchant(params);
      if (response) {
        this.setState(
          {
            ...this.state,
            ...initialSubmitState,
            fetchingRow: false,
            fetchedRow: true,
            hasParams: true,
            isView: action === "view" ? true : false,
            selectedRow: !!response && response.data,
            isDeleteButton: false,
            imageUrl: response.imageUrl ? response.imageUrl : null
          },
          () => {
            this.getMerchantLocations(this.state.selectedRow.id);
          }
        );
      }
    } catch (error) {
      this.setState({
        ...this.state,
        ...initialSubmitState,
        fetchingRow: false,
        fetchedRow: false,
        fetchingError: error,
        selectedRow: null
      });
    }
  };

  selectRow = (selectedRow, action) => {
    this.getMerchant(selectedRow.original.id, action);
  };

  resetButton = () => {
    this.setState({
      ...initailLocationState,
      ...initailUpdateLocationState,
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false,
      isDeleteButton: true
    });
  };

  showConfirmation = selectedRow => {
    if (this.state.showModal) {
      this.setState({
        showModal: !this.state.showModal
      });
    } else {
      this.setState({
        selectedRow: selectedRow.original,
        showModal: !this.state.showModal
      });
    }
  };

  deleteMerchant = item => {
    if (item.id) {
      merchantsService
        .deleteMerchant(item.id)
        .then(response => {
          this.setState({
            response,
            error: null,
            submitting: false,
            deleting: false,
            deleted: true,
            deleteError: null,
            showModal: false,
            hasParams: false,
            selectedRow: null,
            submitted: false,
            isView: false,
            isDeleteButton: true
          });
          this.fetchData();
          toast.success("Merchant deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        })
        .catch(error => {
          this.setState({ formError: error, submitting: false }, () => {
            toast.error(this.state.formError.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });
          });
        });
    }
    this.setState({
      showModal: !this.state.showModal
    });
  };

  setImageNull = () => {
    this.setState({ imageUrl: null });
  };

  render() {
    const {
      fetching,
      fetched,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      deleting,
      deleted,
      deleteError,
      deleteResponse,
      isView,
      imageUrl,
      fetchedRow,
      fetchingError,
      fetchingRow,
      isDeleteButton,
      updatingLocations,
      locationsUpdated,
      locationResponse,
      locationError,
      hasParamsLocation,
      fetchingLocations,
      locationsFetched,
      merchantLocations,
      fetchLocationsError
    } = this.state;

    const locationState = {
      loading: updatingLocations,
      submitted: locationsUpdated,
      response: locationResponse,
      error: locationError,
      hasParams: hasParamsLocation
    };

    const fetchingLocationState = {
      loading: fetchingLocations,
      fetched: locationsFetched,
      response: merchantLocations,
      error: fetchLocationsError
    };

    return (
      <Row>
        <Col sm="4">
          <MerchantForm
            submitting={submitting}
            error={formError}
            hasParams={hasParams}
            selectedRow={selectedRow}
            submitAction={this.addMerchant}
            reset={this.resetButton}
            submitted={submitted}
            isView={isView}
            imageUrl={imageUrl}
            locationState={locationState}
            locationViewState={fetchingLocationState}
            setImageNull={this.setImageNull}
            fetchedRow={fetchedRow}
            fetchingError={fetchingError}
            fetchingRow={fetchingRow}
            isDeleteButton={isDeleteButton}
          />
        </Col>
        <Col sm="8">
          <MerchantTable
            fetching={fetching}
            fetched={fetched}
            data={data}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            error={error}
            filterData={this.filterData}
            DeleteModal={this.DeleteModal}
            deleteRow={this.deleteMerchant}
            showModal={this.showConfirmation}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            selectRow={this.selectRow}
            routeChange={this.routeChange}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.deleteMerchant}
          actionState={{
            sending: deleting,
            sent: deleted,
            error: deleteError,
            response: deleteResponse
          }}
          item={selectedRow}
        />
      </Row>
    );
  }
}

export default ManageMerchants;
